<p-table *ngIf="selectOrder" [value]="[{}]">
  <ng-template pTemplate="header">
    <tr class="table-grey-bg">
      <th width="150px">Date</th>
      <th width="100px" *ngIf="channel != 'RECYKAL'">Payment ID</th>
      <th width="150px">Reference No.</th>
      <th width="150px">Payment Mode</th>
      <th width="150px">Status</th>
      <th>Comment</th>
      <th width="100px">Amount</th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-columns>
    <tr class="custom-table-body">
      <td>
        <ion-text text-regular="" color="medium">{{
          selectOrder?.payment?.paymentSettlement?.createdAt
            | date: "dd-MMM-yy hh:mm a"
        }}</ion-text>
      </td>
      <td *ngIf="channel != 'RECYKAL'">
        <ion-text text-regular="" color="medium">{{
          selectOrder?.payment?.id
        }}</ion-text>
      </td>
      <td>
        <ion-text text-regular="" color="dark">{{
          selectOrder?.payment?.paymentSettlement?.referenceNumber
        }}</ion-text>
      </td>
      <td>
        <ion-text text-regular="" font-bold="" color="medium">{{
          selectOrder?.payment?.paymentSettlement?.orderPaymentMode
        }}</ion-text>
      </td>
      <td>
        <ion-text text-regular="" color="medium">{{
          selectOrder?.payment?.statusTitle
        }}</ion-text>
      </td>
      <td>
        <ion-text text-regular="" color="medium">{{
          selectOrder?.payment?.paymentSettlement?.comment || "-"
        }}</ion-text>
      </td>
      <td>
        <ion-text text-regular="" color="dark" font-bold="">{{
          selectOrder?.payment?.paymentSettlement?.amount | currency: "INR"
        }}</ion-text>
      </td>
    </tr>
  </ng-template>
</p-table>
<ion-grid>
  <ion-row class="border-box">
    <ion-col size="12">
      <ion-row>
        <ion-col size="6">
          <ion-text text-medium="" color="medium"
            >Amount
            <span *ngIf="channel != 'RECYKAL'">{{
              selectOrder?.tradeType === "S" ? "Received" : "Paid"
            }}</span>
            <span *ngIf="channel == 'RECYKAL'">{{
              selectOrder?.tradeType === "B" ? "Received" : "Paid"
            }}</span>
          </ion-text>
        </ion-col>
        <ion-col size="6">
          <ion-text
            text-medium=""
            class="ion-float-right"
            font-bold=""
            color="dark"
            >{{
              selectOrder?.payment?.paymentSettlement?.amountPaid
                | currency: "INR"
            }}</ion-text
          >
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col size="6">
          <ion-text text-medium="" color="medium"
            >Balance to be
            <span *ngIf="channel != 'RECYKAL'">{{
              selectOrder?.tradeType === "S" ? "received" : "paid"
            }}</span>
            <span *ngIf="channel == 'RECYKAL'">{{
              selectOrder?.tradeType === "B" ? "received" : "paid"
            }}</span>
          </ion-text>
        </ion-col>
        <ion-col size="6">
          <ion-text
            text-medium=""
            class="ion-float-right"
            font-bold=""
            color="danger"
            >{{
              selectOrder?.payment?.paymentSettlement?.amount -
                selectOrder?.payment?.paymentSettlement?.amountPaid
                | currency: "INR"
            }}</ion-text
          >
        </ion-col>
      </ion-row>
    </ion-col>
  </ion-row>
</ion-grid>
